import { SelectOption } from '../../../../../components/CiscoUi';
import { PLEASE_SELECT_OPTION } from '../../../../../constants/form';
import { NAT_RULE_SCOPES } from '../../../../../constants/nat-rules';

interface BuildMailServerPayloadProps {
  formData: ExternalDnsFormData;
  topologyUid: TopologyUid['uid'];
}
export const buildExternalDnsPayload = ({
  formData,
  topologyUid,
}: BuildMailServerPayloadProps): ExternalDnsPostPayload => {
  const { natRule, asset, hostname } = formData;
  let payload;
  asset === ''
    ? (payload = {
        hostname: hostname,
        natRule: {
          uid: natRule,
        },
        topology: { uid: topologyUid },
      })
    : (payload = {
        hostname: hostname,
        inventoryDnsAsset: {
          id: asset,
        },
        natRule: {
          uid: natRule,
        },
        topology: { uid: topologyUid },
      });
  if (payload.inventoryDnsAsset?.id === undefined) {
    delete payload.inventoryDnsAsset;
  }
  return payload;
};

export const buildNatOptions = (
  natRules: NatRule[],
): SelectOption<string>[] => {
  const options = natRules
    .filter((natRule) => natRule.scope === NAT_RULE_SCOPES.public)
    .map(({ uid, target }: NatRule) => ({
      name: `${target.name} ( ${target.ipAddress} )`,
      value: uid!,
    }));

  return [PLEASE_SELECT_OPTION, ...options];
};
